<template>
    <router-link
        v-if="url"
        :class="buttonClass"
        :to="url"
        @click.native="handleClick"
        :title="title"
        :disabled="disabled"
    >
        <i v-if="Boolean(icon)" :class="`fa fa-${icon}`"></i> {{ label }}
    </router-link>
    <a
        v-else-if="href"
        :class="buttonClass"
        :href="href"
        :target="target"
        :title="title"
        :disabled="disabled"
    >
        <i v-if="Boolean(icon)" :class="`fa fa-${icon}`"></i> {{ label }}
    </a>
    <a
        v-else
        href="javascript:;"
        :class="buttonClass"
        @click.prevent="handleClick"
        :title="title"
        :disabled="disabled"
    >
        <i v-if="Boolean(icon)" :class="`fa fa-${icon}`"></i> {{ label }}
    </a>
</template>

<script>
export default {
    computed: {
        buttonClass() {
            return `btn btn-${this.color}`;
        },
    },
    methods: {
        handleClick() {
            if (this.disabled) return;
            this.$emit("click", this.$event);
        },
    },
    props: {
        color: {
            type: String,
            required: false,
            default: "default",
        },
        disabled: {
            type: Boolean,
            required: false,
            default: false,
        },
        href: {
            type: String,
            required: false,
            default: null,
        },
        icon: {
            type: String,
            required: false,
            default: null,
        },
        label: {
            type: String,
            required: false,
            default: null,
        },
        target: {
            type: String,
            required: false,
            default: "_blank",
        },
        title: {
            type: String,
            required: false,
            default: null,
        },
        url: {
            type: String,
            required: false,
            default: null,
        },
    },
};
</script>
